/** 
 * IMPORTANT: this must be the only source of truth regarding
 * Grip sections, fields and any other type names and/or datatypes.
 * 
 * All definitions here will be used in components and other
 * places.
 * 
 * @MAZ - 2020-05-24
 */
export const is = {

  // Field Container types
  VALUE: 'Value',              // string, number, bool, date, time, null
  CODE: 'Code',                // { value: '', text: '' }
  URI: 'Uri',                  // { uri: '', 'text': ''; }
  VALUES_ARRAY: 'ValuesArray', // [ is.VALUE, ... ]
  CODES_ARRAY: 'CodesArray',   // [ is.CODE, ...]
  URIS_ARRAY: 'UrisArray',     // [ is.URI, ...]

  // Strict Data types for VALUE containers
  TEXT: '',
  INTEGER: '',
  DECIMAL: '',
  PHONE: '',
  DATE: '',
  TIME: '',
  DATETIME: '',
  BOOL: '',
  BLOB: '',
  URI: '', // File URI (ej: 'xxxxxxx.pdf')
  NULL: null, // avoid using 'undefined' anywhere, just use 'null'

  // Section types
  PLAIN_SECTION: 'PlainSection',
  TABLE_SECTION: 'TableSection',// ListBlock must map to this
  PARAGRAPH_SECTION: 'ParagraphSection',

  // Field types
  TEXT_FIELD: 'TextField',
  NUMBER_FIELD: 'NumberField',
  INTEGER_FIELD: 'NumberField:integer',
  DECIMAL_FIELD: 'NumberField:decimal',
  PHONE_FIELD: 'NumberField:phone',
  DATE_FIELD: 'DateField',
  TIME_FIELD: 'TimeField',
  CHECK_FIELD: 'CheckField',
  OPTION_FIELD: 'OptionField',
  ITEM_FIELD: 'ItemField',
  QRCODE_FIELD:  'QRCodeField',
  CALCULATED_FIELD:  'CalculatedField',
  PHOTOS_FIELD: 'PhotosField',
  ATTACHS_FIELD: 'AttachsField',
  GRAPH_FIELD: 'GraphField',
  LOCAL_STOCK_FIELD: 'LocalStockPlugin',
  LOCAL_TICKET_FIELD: 'LocalTicketPlugin',
  EMAIL_ALERT_FIELD: 'EmailAlertPlugin',
  REMOTE_CALL_FIELD: 'RemoteCallPlugin',
  
  // Action Plugin types
  FUSION_PDFS_PLUGIN: 'PdfFusionPlugin',
  COPY_COLUMNS_PLUGIN: 'ListColumnsCopy',
  FILTER_ROWS_PLUGIN: 'ConditionalRowsOnly',
  SHOW_FIELDS_PLUGIN: 'ConditionalFieldsOnly',
  SHOW_SECTIONS_PLUGIN: 'ConditionalSectionsOnly',
  
  // Not available yet !
  PARAGRAPH_FIELD: 'ParagraphField',
  MULTI_ITEMS_FIELD: 'MultiItemsField',
  MULTI_OPTIONS_FIELD: 'MultiOptionsField',
  GRID_SECTION: 'GridSection',

  // Deprecated
  LIST_SECTION: 'ListSection',

  // Record States
  DRAFT: 'B',
  CREATED: 'C',
  EDITION: 'E',
  REVIEW: 'R',
  APPROVED: 'AP',
  REJECTED: 'RX',
  CLOSED: 'F',
  DELETED: 'X',

  aSection(type) {
    return(
      [is.PLAIN_SECTION, is.TABLE_SECTION, is.PARAGRAPH_SECTION]
      .includes(type)
    )
  },

  aCode(type) {
    return(
      [is.OPTION_FIELD, is.ITEM_FIELD]
      .includes(type)
    )
  }
}

/**
 * Normalize types and codes for use in the App
 */

export function remapTypes(otype, osubtype) {
  /**
   * Remaps the section/control type to a valid Type name.
   * @otype: the Section or Control type.
   * @osubtype: the Section or Control subtype (not usually needed)
   * @returns: the remapped type, or the original type (if valid).
   */
  var remapped = {
    "SectionBlock": is.PLAIN_SECTION,
    "ListBlock": is.TABLE_SECTION,
    "ParagraphBlock": is.PARAGRAPH_SECTION,
    "PhotoField": is.PHOTOS_FIELD,
    "ObjectSelectorField": is.ITEM_FIELD,
    "QRcodeField": is.QRCODE_FIELD
  }
  return (remapped[otype] || otype) ;
}


export function isVisibleType(type) {
  /**
   * Determines if the field is of a Visible type 
   * or a hidden one.
   */
  let r = [
    is.FUSION_PDFS_PLUGIN,
    is.COPY_COLUMNS_PLUGIN,
    is.FILTER_ROWS_PLUGIN,
    is.SHOW_FIELDS_PLUGIN,
    is.SHOW_SECTIONS_PLUGIN,
  ].includes(remapTypes(type))
  return (!r);
}
